export default {
  root: {
    flex: "1 1 auto",
    fontFamily: 'Albert Sans", sans-serif',
    minWidth: 0,
    marginTop:" 4px",
    marginBottom: 0
  }
};
